<template lang="">
  <v-main>
    <v-container fluid>
    </v-container>
  </v-main>
</template>

<script>
export default {
  name: 'logoutPage',
  beforeCreate: async function() {
    await this.$store.dispatch('auth/destroy', this.$store.getters['auth/isAuth']);
    this.$router.push('/');
    location.reload();
  }
}
</script>